import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';

import FormControl, { FormControlProps } from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';


/**
 * Used to extend the onchange event for react-final-form Field => MUI FormControl wrappers.
 */
export interface IOnChangeableSelect {
    onChange: (event: any) => void;
}

interface ISelectWrapperProps extends FieldRenderProps<any, any> {
    label?: string;
    formControlProps?: FormControlProps;
    onChangeable?: IOnChangeableSelect;
}

export const SelectWrapper: React.FunctionComponent<ISelectWrapperProps> = ({
    input: { name, value, onChange, ...restInput },
    meta,
    label,
    formControlProps,
    onChangeable,
    ...rest
}) => {
    const showError = meta.touched && (meta.error || (meta.submitError && !meta.dirtySinceLastSubmit)) && !meta.submitting;

    const onChangeFunc = React.useCallback((event: React.ChangeEvent<{ name?: string | undefined; value: unknown; }>, child: React.ReactNode) => {
        onChange(event);

        if (onChangeable) {
            onChangeable.onChange(event);
        }
    }, [onChange, onChangeable]);

    return (
        <FormControl {...formControlProps} error={showError}>
            {!!label && <InputLabel htmlFor={name}>{label}</InputLabel>}

            <Select
                {...rest}
                name={name}
                onChange={onChangeFunc}
                inputProps={restInput}
                value={value}
            />

            {showError &&
                <FormHelperText>{meta.error || meta.submitError}</FormHelperText>
            }
        </FormControl>
    );
};